import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {SharedModule} from '../../shared/shared.module';
import {DeliveryRoutingModule} from './delivery-routing.module';
import {DeliveryComponent} from './delivery.component';
import {BdcSharedModule} from '../shared/bdc-shared.module';
import { ConfirmInfoComponent } from './confirm-info/confirm-info.component';

@NgModule({
  declarations: [
    DeliveryComponent,
    ConfirmInfoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BdcSharedModule,
    DeliveryRoutingModule
  ]
})
export class DeliveryModule { }
